<template>
  <div class="nav">
    <router-link class="link" v-if="previous_item && desktop" :to=" previous_item.url_title ">
      <p>back</p>
      <h2>{{ previous_item.title }}</h2>
    </router-link>
    <router-link class="link home" to="/">
      <p>home</p>
    </router-link>
    <router-link class="link" v-if="next_item" :to=" next_item.url_title ">
      <p>next</p>
      <h2>{{ next_item.title }}</h2>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AlbumNav",
  computed: {
    desktop: function() {
      return window.innerWidth > 732;
    },
    ...mapGetters(["current_item", "previous_item", "next_item"])
  }
};
</script>

<style scoped lang="scss">
.nav {
  width: 100%;
  margin: 4rem 2rem;
  font-size: 1.7em;
  @include bigScreen {
    display: grid;
    grid-template-columns: 3fr 2fr 3fr;
  }

  .home {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2em;
  }
}
</style>
